import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  Label,
  CardSubtitle,
  Container,
  Spinner,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";

import showNotification from "../../../helpers/show_notification";

import { postSubmitForm } from "../../../helpers/forms_helper";

const AddEquipCategory = (props) => {
  const [subCategories, setSubCategories] = useState([]);

  useEffect(() => {
    loadAllCategories();
  }, []);

  const [allCategories, setAllCategories] = useState([]);
  const loadAllCategories = async (e, v) => {
    let url = process.env.REACT_APP_BASEURL + "equipmentcategories/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllCategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const refContainer = useRef(null);

  const [isLoading , setIsLoading] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      const object = {
        category: v.name,
        sub_category: subCategories,
      };
      setIsLoading(true)
      let url = process.env.REACT_APP_BASEURL + "equipmentcategories/insert";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllCategories();
        setSubCategories([]);
        showNotification(response.message, "Success");
        refContainer.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
      setIsLoading(false)
    }
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Category Name"),
      //formatter: employeeFormatter,
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "16%" };
      },
    },
    {
      text: props.t("Sub-Categories"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <>
            {row.sub_category.map((subcategory) => {
              // console.log(subcategory);
              return (
                <span class="font-size-12 mr-2 badge-soft-success badge badge-success badge-pill">
                  {subcategory}
                </span>
              );
            })}
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "35%" };
      },
    },
  ];
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Equipment Categories")}
            breadcrumbItem={props.t("Add Equipment Category")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleValidSubmit} ref={refContainer}>
                    <CardTitle>{props.t("Add Equipment Category")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t(
                        "Enter the following details to add a new Equipment category"
                      )}
                    </CardSubtitle>
                    <Row>
                      <Col lg={6}>
                        <AvField
                          name="name"
                          label={props.t("Category")}
                          placeholder={props.t("Enter Category Name")}
                          type="text"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: props.t("Name cannot be empty"),
                            },
                          }}
                        />
                      </Col>
                      <Col lg={6}>
                        <Label>{props.t("Sub-Category Name")}</Label> (
                        {props.t("press ENTER/TAB to add")})
                        <TagsInput
                          value={subCategories}
                          onChange={(tags) => {
                            setSubCategories(tags);
                          }}
                          onlyUnique={true}
                          inputProps={{
                            className: "react-tagsinput-input",
                            placeholder: props.t("Add..."),
                          }}
                        />
                      </Col>

                      <Col lg={12}>
                        <hr />
                        <FormGroup className="mb-0 text-center">
                        <div>
                        <Button type="submit" color="primary" className="mr-1" disabled={isLoading} style={{width:"100px"}}>
                          { isLoading ? <Spinner size={"sm"}/> :props.t("Submit")}
                        </Button>
                      </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Existing Equipment Categories")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all your existing equipment categories here")}
                  </CardSubtitle>
                  <BootstrapTable
                    bootstrap4
                    keyField="_id"
                    data={allCategories && allCategories}
                    columns={columns}
                    noDataIndication={props.t("No data to display.")}
                    striped
                    hover
                    condensed
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(AddEquipCategory)));
